import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'console';
import { AwsService, CreditosService, ListasService, UsuarioService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';
import { Idd } from '../../../../models/usuario.model';

@Component({
  selector: 'app-alta-empleado',
  templateUrl: './alta-empleado.component.html',
  styleUrls: ['./alta-empleado.component.css']
})
export class AltaEmpleadoComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  documentos = false;
  panelPersonales = false;
  panelContributor = false;
  panelAddress = false;
  panelCustomer = false;
  panelReferences = false;
  panelJob = false;
  countries = [];
  states = [];
  municipies = [];
  colonias = [];
  capturaCp = false;
  regimen = '';
  first_name = '';
  last_name = '';
  second_last_name = '';
  docArray = [];
  tipo_ine = '';

  person = new FormGroup({
    fiscal_regime : new FormControl(null),
    first_name : new FormControl(null),
    last_name : new FormControl(null),
    second_last_name : new FormControl(null),
    gender : new FormControl(null),
    birthdate : new FormControl(null),
    nationality : new FormControl(null),
    birth_country : new FormControl(null),
    birthplace : new FormControl(null),
    phone : new FormControl(null),
    mobile : new FormControl(null),
    email : new FormControl(null),
    martial_status : new FormControl('SO'),
    martial_regime : new FormControl('NA'),
    minior_dependents : new FormControl('0'),
    senior_dependents : new FormControl('0'),
    id_type : new FormControl(null),
    identification : new FormControl(null),
    rfc : new FormControl(null),	
    curp : new FormControl(null),
    imss : new FormControl(null),
    fiel : new FormControl('NA'),
    housing_type : new FormControl(null),
    ocr : new FormControl(null),
    citizen_id : new FormControl(null),
    /* 
    id : new FormControl(null),
    extra1 : new FormControl(null),
    extra2 : new FormControl(null),
    extra3 : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null), */
  });

  contributor = new FormGroup({
    contributor_type : new FormControl(null),
    bank : new FormControl(null),
    account_number : new FormControl(null),
    clabe : new FormControl(null),
    bank_key: new FormControl(),
    /* extra1 : new FormControl(null),
    extra2 : new FormControl(null),
    extra3 : new FormControl(null),
    person_id : new FormControl(null),
    legal_entity_id : new FormControl(null),
    id : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null), */
  });

  contributor_address = new FormGroup({
    address_type : new FormControl('PARTICULAR', null),
    suburb : new FormControl(null),
    suburb_type : new FormControl(null),
    street : new FormControl(null),
    external_number : new FormControl(null),
    apartment_number : new FormControl(null),
    postal_code : new FormControl(null),
    address_reference : new FormControl(null),
    state_id : new FormControl(null),
    municipality_id : new FormControl(null),
    /* contributor_id : new FormControl(null),
    id : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null), */
  });

  gov_customer = new FormGroup({
    first_name : new FormControl(null),
    last_name : new FormControl(null),
    second_last_name : new FormControl(null),
    age : new FormControl(null),
    public_charge : new FormControl({value: 'SI', disabled: true}),
    public_charge_det : new FormControl(''),
    relative_charge : new FormControl(null),
    relative_charge_det : new FormControl(''),
    responsible : new FormControl(null),
    responsible_detail : new FormControl(''),
    salary : new FormControl('0'),
    salary_period : new FormControl(null),
    extra_income : new FormControl('0'),
    expenses : new FormControl('0'),
    extra_expenses : new FormControl('0'),
    payment_capacity : new FormControl({value: '', disabled: true}),
    customer_type : new FormControl(null),
    company_id : new FormControl(null),
    /* id : new FormControl(null),
    extra1 : new FormControl(null),
    extra2 : new FormControl(null),
    extra3 : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null),
    contributor_id : new FormControl(null),
    file_type_id : new FormControl(null), */
  });

  customer_personal_references = new FormGroup({
    first_name : new FormControl(null),
    last_name : new FormControl(null),
    second_last_name : new FormControl(null),
    address : new FormControl(null),
    phone : new FormControl(null),
    reference_type : new FormControl(null),
    /* id : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null),
    customer_id : new FormControl(null), */
  });

  gov_actual_jobs = new FormGroup({
    agency : new FormControl(null),
    seniority : new FormControl(null),
    direct_boss : new FormControl('NA'),
    title : new FormControl(null),
    area : new FormControl(null),
    department : new FormControl(null),
    office_phone : new FormControl(null),
    /* extra1 : new FormControl(null),
    extra2 : new FormControl(null),
    extra3 : new FormControl(null),
    id : new FormControl(null),
    created_at : new FormControl(null),
    updated_at : new FormControl(null),
    gov_customer_id : new FormControl(null), */
  });
  lists = [];
  generos = [];
  maritalStatus = [];
  regimenFiscal = [];
  addressType = [];
  suburbType = [];
  banks = [];
  companies = [];
  mantenimiento = false;
  pais = '';
  paisNac = '';
  govCustomerId = '';
  govCustomerObject = {};
  showModal = false;
  calculo = '';
  person_id: any;
  contributor_id: any;
  contributor_address_id: any;
  gov_customer_id: any;
  gov_actual_job_id: any;
  regimenMatrimonial = [];
  
  constructor(private aws: AwsService,
              private listasService: ListasService,
              private usuarioService: UsuarioService,
              private route: ActivatedRoute,
              public router: Router,
              private creditosService: CreditosService
  ) { }

  async ngOnInit() {
    await this.aws.getCountriesD().toPromise().then(resp => { this.countries = resp; }, error => { console.log(error); });
    await this.listasService.getLists().subscribe(lists => {
      lists['data'].forEach(list => {
        this.lists.push(list.attributes);
      });
      this.generos = this.lists.filter(p => p.domain === 'USER_GENDER');
      this.maritalStatus = this.lists.filter(p => p.domain === 'PERSON_MARTIAL_STATUS');
      this.regimenFiscal = this.lists.filter(p => p.domain === 'CONTRIBUTOR_FISCAL_REGIME');
      this.addressType = this.lists.filter(p => p.domain === 'CONTRIBUTOR_ADDRESS_ADDRESS_TYPE');
      this.suburbType = this.lists.filter(p => p.domain === 'CONTRIBUTOR_ADDRESS_SUBURB_TYPE');
      this.regimenMatrimonial = this.lists.filter(p => p.domain === 'PERSON_MARITAL_REGIME');
      this.aws.getYucatanCompanyes().subscribe(resp => {
        this.companies = resp;
      })
    })
    
    if(this.route.snapshot.paramMap.get('customer_id')){
      this.mantenimiento = true;
      this.govCustomerId = this.route.snapshot.paramMap.get('customer_id');
      this.usuarioService.getGovCustomer(this.govCustomerId).subscribe(resp => {
        this.govCustomerObject = resp['data'];
        this.person_id = resp['data'].id;
        this.contributor_id = resp['data']['relations']['contributors'][0].id;
        this.contributor_address_id = resp['data']['relations']['contributor_addresses'][0].id;
        this.gov_customer_id = resp['data']['relations']['gov_customers'][0].id;
        this.gov_actual_job_id = resp['data']['relations']['gov_actual_job'][0].id;
        resp['data']['relations']['contributors'][0]
        Object.keys(this.person.value).forEach(k => {
          this.person.get(k).setValue(resp['data'].attributes[k]);
        })
        if(this.person.get('citizen_id').value != null && this.person.get('citizen_id').value != ''){
          this.tipo_ine = 'id';
        }else if(this.person.get('ocr').value != null && this.person.get('ocr').value != ''){
          this.tipo_ine = 'ocr';
        }
        Object.keys(this.contributor.value).forEach(k => {
          this.contributor.get(k).setValue(resp['data']['relations']['contributors'][0]['attributes'][k]);
        })
        Object.keys(this.contributor_address.value).forEach(k => {
          if(k == 'postal_code'){
            this.getColonias(resp['data']['relations']['contributor_addresses'][0]['attributes']['postal_code']);
          }
          if(k == 'state_id'){
            // this.pais = this.countries.find(p => p.name == 'México').id
            this.pais = this.countries.find(p => p.id == this.govCustomerObject['attributes']['birth_country']).id
            this.buscaEdo(this.pais);
          }
          if(k == 'municipality_id'){
            this.buscaMun(resp['data']['relations']['contributor_addresses'][0]['attributes']['state_id']);
          }
          this.contributor_address.get(k).setValue(resp['data']['relations']['contributor_addresses'][0]['attributes'][k]);
        })
        Object.keys(this.gov_customer.value).forEach(k => {
          this.gov_customer.get(k).setValue(resp['data']['relations']['gov_customers'][0]['attributes'][k]);
          resp['data']['relations']['gov_customers'][0]['attributes']['payment_capacity'] = (parseFloat(resp['data']['relations']['gov_customers'][0]['attributes']['salary']) + parseFloat(resp['data']['relations']['gov_customers'][0]['attributes']['extra_income'])) * 0.3;
          this.calculoCapacidad();
        })
        Object.keys(this.gov_actual_jobs.value).forEach(k => {
          this.gov_actual_jobs.get(k).setValue(resp['data']['relations']['gov_actual_job'][0]['attributes'][k]);
        })
        this.docArray = [];
        resp['data']['relations']['contributor_documents'].forEach(d => {
          this.docArray.push(d.attributes);
        });
      });
    }
    

  this.aws.getBankNumber().subscribe(resp => { this.banks = resp; })

    
  }

  validaCURP(){
    var regex = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HMX](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS)[B-DF-HJ-NP-TV-ZÑ]{3}[A-Z0-9])(\d)$/;
    var curp = this.person.value.curp;
    if(curp == '' || curp == null){ return}
    curp = curp.toUpperCase();
    this.person.patchValue({curp: curp});
    if(!regex.test(curp)){
      swal2.fire('Atención', 'El CURP no es válido', 'info');
      this.person.patchValue({curp: ''});
      return;
    }
    this.infoCurp();
  }

  async infoCurp(){
    var curp = this.person.value.curp;
    const regex = /^([A-Z]{4})(\d{2})(\d{2})(\d{2})([HM])([A-Z]{2})/;
    const match = curp.toUpperCase().match(regex);

    if (!match) return null;
      // fecha de nacimiento
    let year = parseInt(match[2], 10);
    const month = parseInt(match[3], 10);
    const day = parseInt(match[4], 10);

    // CURP usa dos dígitos, se decide el siglo
    year += year < 30 ? 2000 : 1900;

    const birthDate = new Date(year, month - 1, day);

    // sexo
    const sex = match[5] === "H" ? "Hombre" : "Mujer";

    // estado de nacimiento (catálogo oficial RENAPO)
    const estados: Record<string, string> = {
      AS: "Aguascalientes", BC: "Baja California", BS: "Baja California Sur",
      CC: "Campeche", CL: "Coahuila", CM: "Colima", CS: "Chiapas", CH: "Chihuahua",
      DF: "Ciudad de México", DG: "Durango", GT: "Guanajuato", GR: "Guerrero",
      HG: "Hidalgo", JC: "Jalisco", MC: "México", MN: "Michoacán", MS: "Morelos",
      NT: "Nayarit", NL: "Nuevo León", OC: "Oaxaca", PL: "Puebla", QT: "Querétaro",
      QR: "Quintana Roo", SP: "San Luis Potosí", SL: "Sinaloa", SR: "Sonora",
      TC: "Tabasco", TS: "Tamaulipas", TL: "Tlaxcala", VZ: "Veracruz", YN: "Yucatán", ZS: "Zacatecas",
      NE: "Nacido en el Extranjero"
    };

    const state = estados[match[6]] || "Desconocido";

    // RFC → primeros 10 caracteres del CURP
    // const rfc = curp.substring(0, 10);
    swal2.fire({
      title: 'Captura el RFC con homoclave',
      input: "text",
      showCancelButton: false,
      confirmButtonText: "Guardar",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        const input = swal2.getInput();
        input.style.textTransform = 'uppercase';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.person.patchValue({rfc: result.value.toUpperCase()} );
      }
    }
  )
    // país y nacionalidad (siempre México salvo NE)
    const country = match[6] === "NE" ? "Extranjero" : "México";
    const nationality = match[6] === "NE" ? "Extranjero" : "Mexicana";

    // console.log( birthDate, sex, state, rfc, country, nationality );
    this.person.patchValue({nationality: nationality});
    if(sex == 'Hombre'){
      this.person.patchValue({gender: 'MA'});
    }else if(sex == 'Mujer'){
      this.person.patchValue({gender: 'FE'});
    }
    // this.person.patchValue({rfc: rfc});

    var birthCountry = this.countries.find(p => this.limpiarAcentos(p.name) === this.limpiarAcentos(country)).id;
    this.person.patchValue({birth_country: birthCountry});
    await this.buscaEdo(birthCountry);
    var birthPlace = this.states.find(s => this.limpiarAcentos(s.name) == this.limpiarAcentos(state)).id;
    // console.log(state, this.limpiarAcentos(state), birthPlace);
    this.person.patchValue({birthplace: birthPlace});
    this.person.patchValue({birthdate: birthDate.toISOString().split('T')[0]});
  }

  limpiarAcentos(cadena){
    var normalizada = (cadena ?? "").toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")             // acentos
      .replace(/[\u00AD\u200B-\u200D\u2060\u180E]/g, "") // soft/zero-width
      .replace(/[\uFEFF\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/g, " ") // espacios raros → espacio
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")                 // cualquier separador → espacio
      .replace(/\s+/g, " ")                        // colapsa espacios
      .trim();
    return normalizada;
  }

  calculoCapacidad(){
    this.calculo = ((parseFloat(this.gov_customer.get('salary').value) + parseFloat(this.gov_customer.get('extra_income').value)) * 0.3).toString();
    let regex = /(\d*.\d{0,2})/; 
    this.calculo = this.calculo.toString().match(regex)[0];

    this.calculo = this.calculo.replace(/[^0-9.]/g, '');
    
    // mantengo solo el primer decimal
    const parts = this.calculo.split('.');
    if (parts.length > 2) {
      this.calculo = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // formateo y limito a solo dos decimales
    let [integerPart, decimalPart] = this.calculo.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    decimalPart = (decimalPart || '').padEnd(2, '0').substring(0, 2);

    // actualizo visualmente
    // input.value = `${integerPart}${decimalPart ? '.' + decimalPart : ''}`;
    this.calculo = `${integerPart}${decimalPart ? '.' + decimalPart : ''}`



    this.gov_customer.get('payment_capacity').setValue(this.calculo);
    // this.gov_customer.value['payment_capacity'] = this.calculo;
  }

  // para validar y limitar el número de decimales en tiempo real
  validateInput(event: any) {
    const input = event.target as HTMLInputElement;
    var value = this.creditosService.limitarDecimales(event);
    input.value = value;
  }
  
  // Para cuando pierda el foco formatear
  fmCurrency(event: any) {
    const input = event.target as HTMLInputElement;
    var value = this.creditosService.formatearFocoPerdido(event);
    input.value = value;
  }

  dragEnter(id: string) {
    document.getElementById(id).style.border = "dashed 3px #73CB38";
  }
  dragLeave(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    document.getElementById(id).style.border = "dashed 1px #979797";
  }

  hideds(){
    this.showModal = false;
    swal2.fire('Atención', 'Empleado creado correctamente', 'success').then(result => {
      if(result.isConfirmed){
        window.location.reload();

      }
    })
  }

  guardarModal(){
    this.showModal = false;
    swal2.fire('Atención', 'Empleado creado correctamente', 'success').then(result => {
      if(result.isConfirmed){
        window.location.reload();

      }
    })
  }

  async fileBrowseHandler( event: any, doc: string, idd ) {
    const file: File = event.target.files[0];

  if (file && file.type !== 'application/pdf') {
    swal2.fire('Atención', 'Solo se permiten archivos PDF', 'info');
    event.target.value = ''; // Limpia el input
    return;
  }
    await this.callupload(file, idd);
  }

  async callupload(file, idd) {
    try {
      const r = await this.aws.uploadFileSB(file, this.govCustomerId);
      console.log(r);
      (await this.aws.patchUrl(this.govCustomerObject['relations']['contributors'][0].id, idd, r['url'])).toPromise().then(resp => {
        var index = this.docArray.findIndex(p => p.id == idd);
        this.docArray[index].url = r['url'];
        this.docArray[index].status = 'IN';
      });
    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al subir archivo'
      }
      try{
        swal2.fire(error.error.error, error.error.exception, 'info');
      }catch{
        swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
      }
      return resp
    }
  }

  async eliminaDocumento(idd){
    (await this.aws.eliminaDocumento(this.govCustomerObject['relations']['contributors'][0].id, idd, '')).toPromise().then(resp => {
      var index = this.docArray.findIndex(p => p.id == idd);
      this.docArray[index].url = '';
      this.docArray[index].status = 'PI';
    });
   }

   setBankCode(value){
    var bank = this.banks.find(b => b.value == value);
    if (bank) {
      this.contributor.patchValue({bank_key: bank.extra1});
    }
   }

  async buscaEdo(id) {
  //  await this.aws.getStatesId(id).subscribe( r => {this.states = r;} )
  this.states = await this.aws.getStatesId(id).toPromise();
}

async buscaMun(id) {
  // this.aws.getMunicipios(id).subscribe( r => {this.municipies = r;} )
  this.municipies = await this.aws.getMunicipios(id).toPromise();
  }

  getColonias(event) {
    this.aws.getColoniasxcp(event).subscribe(async r => {
      this.colonias = r;
      this.capturaCp = true;
      if(this.colonias.length > 0){
        this.pais = "";
        this.contributor_address.patchValue({municipality_id: ""});
        this.contributor_address.patchValue({state_id: ""});
        this.capturaCp = false;
        this.pais = this.countries[0].id;
        await this.buscaEdo(this.pais);
        var edo = this.states.find(s => this.limpiarAcentos(s.name) == this.limpiarAcentos(this.colonias[0].state)).id;
        await this.buscaMun(edo);
        this.contributor_address.patchValue({state_id: edo});
        var mun = this.municipies.find(m => this.limpiarAcentos(m.name) == this.limpiarAcentos(this.colonias[0].municipality)).id;
        this.contributor_address.patchValue({municipality_id: mun});
      }
    })
  }

  cerraroregusu() {
    this.childEvent.emit({message: 'cerrarcreausr'})
  }

  regUsr(){
    document.getElementById('btnGuardar').setAttribute('disabled', 'true');
    if(this.person.get('id_type')?.value === 'INE' && !this.person.get('citizen_id').value && !this.person.get('ocr').value){
      swal2.fire('Atención', 'Debe capturar el número de identificación del INE', 'info');
      document.getElementById('btnGuardar').removeAttribute('disabled');
      return;

    }
    var params = {};
    // params['rfc'] = 'AABB999199A7';
    // params['company_rfc'] = this.company['rfc'];
    params['type'] = 'customer';
    this.person.value['fiscal_regime'] = this.contributor.value.contributor_type;
    params['person'] = this.person.value;
    params['contributor'] = this.contributor.value;
    params['contributor_address'] = this.contributor_address.value;
    /* this.gov_customer.value['first_name'] = this.first_name;
    this.gov_customer.value['last_name'] = this.last_name;
    this.gov_customer.value['second_last_name'] = this.second_last_name; */
    this.gov_customer.value['customer_type'] = 'PFGY';
    this.gov_customer.value['salary'] = this.gov_customer.value['salary'].replace(/,/g, '');
    this.gov_customer.value['extra_income'] = this.gov_customer.value['extra_income'].replace(/,/g, '');
    params['gov_customer'] = this.gov_customer.value;
    params['gov_actual_job'] = this.gov_actual_jobs.value;
    this.calculo = this.calculo.replace(/,/g, '');
    params['gov_customer']['payment_capacity'] = this.calculo; 
    console.log(params);
    
    if(!this.mantenimiento){
      params['adviser_user_id'] = localStorage.getItem('uid');
      params['customer_personal_references'] = this.customer_personal_references.value;
      this.usuarioService.crearEmpleadoYucatan(params).subscribe(resp => {
        // window.location.reload();
        console.log(resp);
        document.getElementById('btnGuardar').removeAttribute('disabled');
        this.govCustomerObject = resp['data'];
        this.docArray = [];
        resp['data']['relations']['contributor_documents'].forEach(d => {
          this.docArray.push(d.attributes);
        });
        this.showModal = true;
      }, error => {
        document.getElementById('btnGuardar').removeAttribute('disabled');
        console.log(error);
        try{
          if(typeof(error.error.error) == 'string'){
            swal2.fire('Atención', error.error.error, 'error');
          }else{
            var mensaje = '';
            Object.keys(error.error.error).forEach(k => {
              mensaje += k + ': ' + error.error.error[k][0] + '\n';
            })
            console.log(mensaje);
            swal2.fire({
              title: 'Atención',
              html: mensaje,
              icon: 'error'
            });
          }
        }catch{
          try{
            swal2.fire('Atención', error.error.errors[0], 'error');
          }catch{
            swal2.fire('Atención', 'Algo salió mal', 'error');
          }
        }
      })
    }else{
      params['person_id'] = this.person_id;
      params['contributor_id'] = this.contributor_id;
      params['contributor_address_id'] = this.contributor_address_id;
      params['gov_customer_id'] = this.gov_customer_id;
      params['gov_actual_job_id'] = this.gov_actual_job_id;
      this.usuarioService.actualizaEmpleadoYucatan(this.govCustomerId, params).subscribe(resp => {
        console.log(resp);
        swal2.fire('Éxito', 'Empleado actualizado correctamente', 'success').then((result) => {
          document.getElementById('btnGuardar').removeAttribute('disabled');
          if (result.isConfirmed) {
            this.router.navigate(['/panelcontrol/empleadosGobierno']);
          }
        });
      },error => {
        document.getElementById('btnGuardar').removeAttribute('disabled');
        console.log(error);
        try{
          swal2.fire('Atención', error.error.errors[0], 'error');
        }catch{
          swal2.fire('Atención', 'Algo salió mal', 'error');
        }
      });
    }
  }

}
